// @ts-check
import React, { lazy, Suspense } from "react";
import "./Externo.scss";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import SplashScreen from "../../pages/splachscreen/page";
import Caducado from "./Caducado";
import Study from "../../models/studies/study";
import { VerifyJWT } from "../../utils/jwtTools";
import { getStudy } from "../../service/study.service";
import { getInform } from "../../service/informs.service";

const Visor = lazy(() => import("../NuevoVisor/Visor"));

function Externo() {
  const { token } = useParams();
  const [Listo, setListo] = useState(
    /** @type {{listo: boolean, acceso: boolean, estudio: Study | null, informes: import("../../models/studies/report").ReportItem[]}} */ ({
      listo: false,
      acceso: false,
      estudio: null,
      informes: [],
    }),
  );
  let contenido;
  useEffect(() => {
    if (!token) return;
    (async () => {
      try {
        // @ts-ignore
        const { ID } = VerifyJWT(token);
        const [study, report] = await Promise.all([
          getStudy(ID),
          getInform(ID),
        ]);
        setListo({
          listo: true,
          acceso: true,
          estudio: study,
          informes: report,
        });
      } catch (error) {
        console.log(error);
      }
    })();
  }, [token]);
  if (Listo.listo) {
    if (Listo.acceso && Listo.estudio) {
      contenido = (
        <Suspense fallback={<div>Cargando...</div>}>
          <Visor
            estudio={Listo.estudio}
            informe={Listo.informes}
            extern={true}
          />
        </Suspense>
      );
    } else {
      contenido = <Caducado />;
    }
  } else {
    contenido = <SplashScreen message="Cargando Componentes" />;
  }
  return <div id="Externo">{contenido}</div>;
}
export default Externo;
